var _linearGradient, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbaEntryLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_9304d5155b5da9478af8bb7bde7fb8ea43e7541914a8962e5c78b7da479e55f9",
    gradientUnits: "userSpaceOnUse",
    x1: 27.312,
    y1: 56.413,
    x2: 63.592,
    y2: 56.413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_0_9304d5155b5da9478af8bb7bde7fb8ea43e7541914a8962e5c78b7da479e55f9)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M27.937 56.413h35.029"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M37.165 39.597h13.192M39.364 42.366h8.469"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.966 53.311V4.778H22.034l.028 51.365"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M62.966 53.31H25.167a3.114 3.114 0 00-3.105 3.105 3.114 3.114 0 003.105 3.105h37.799v-6.21zM24.831 38.216v4.157M24.831 16.183v4.157M52.802 46.784H34.476a2.93 2.93 0 01-2.93-2.93v-5.5a2.93 2.93 0 012.93-2.93h18.326a2.93 2.93 0 012.93 2.93v5.5a2.93 2.93 0 01-2.93 2.93z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M39.445 23.906h10.432M47.421 20.603l3.335 3.335-3.375 3.533M47.1 16.583H36.292M38.749 19.886l-3.336-3.336 3.375-3.533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbaEntryLedger);
export default __webpack_public_path__ + "static/media/cbaEntryLedger.ade75559fad5dc9c52f4c7ce7a595d20.svg";
export { ForwardRef as ReactComponent };